import axios from 'axios';
import { organizationLocalStorageItem } from 'services/organization/atom';
import { graphqlService } from './graphqlService';
import { getCurrentAuthToken } from './graphqlService';
import { baseURLByEnv, env } from 'core/config';

type RestConfig = { isPublic?: boolean };

// Export the graphql service
export const graphql = graphqlService;

const RestInstance = axios.create({
  baseURL: baseURLByEnv[env.STAGE]
});

const getHeaders = async ({ isPublic }: { isPublic?: boolean }) => {
  if (isPublic) {
    return undefined;
  }

  const organization = organizationLocalStorageItem();
  const token = await getCurrentAuthToken();

  const headers: { [key: string]: string } = {
    Authorization: `Bearer ${token}`
  };

  if (organization?.id) {
    headers['organization-id'] = organization?.id;
  }

  return headers;
};

export const rest = {
  get: async (
    endpoint: string,
    params?: { [k: string]: string },
    config?: RestConfig
  ) => {
    const { isPublic } = config || {};

    const { data } = await RestInstance.get(endpoint, {
      params,
      headers: await getHeaders({
        isPublic
      })
    });
    return data;
  },
  post: async (
    endpoint: string,
    body: { [k: string]: any },
    config?: RestConfig
  ) => {
    const { isPublic } = config || {};

    const { data } = await RestInstance.post(endpoint, body, {
      headers: await getHeaders({
        isPublic
      })
    });
    return data;
  }
};

export const getFunctionUrlEndpointById = (id: string) =>
  `https://${id}.lambda-url.eu-west-2.on.aws/`;
